import Vue from 'vue'


/**
 * 修改 title 值
 * @param {string} title
 * @returns {any}
 */
const changeTitle = (title: string) => {
    document.title = title
}

Vue.prototype.$title = changeTitle
